
// 要在父级组件的根节点 触发 this.$store.dispatch('orderUser/getUserInfo')

import { getUserInfo } from '@@/api/center'
import { getPcbaUserInfo } from '@@/api/pcba'

// 缓存请求，防止同一时间多次重复请求
let requestCache = null

const state = {
  userInfo: {
    feGetInfoEnd: false // 是否获取用户信息结束 用于统计代码执行
  },
  isLogin: false,
  pcbaUserInfo: {}  // PCBA用户信息
}

const getters = {
  userInfo(state) {
    return state.userInfo
  },
  isLogin(state) {
    return state.isLogin
  },
  pcbaUserInfo(state) {
    return state.pcbaUserInfo
  }
}

const mutations = {
  setUserInfo(state, info) {
    state.userInfo = info
  },
  setIsLogin(state, isLogin) {
    state.isLogin = isLogin
  },
  SET_PCBA_USER_INFO(state, pcbaUserInfo) {
    state.pcbaUserInfo = pcbaUserInfo
  }
}

const actions = {
  async getUserInfo({ commit }) {
    const res = await getUserInfo({})
    if (res && res.suc) {
      // 后端返回的是json字符串加密后的
      const result = JSON.parse(res.body)
      const userData = result
      userData.feGetInfoEnd = true
      commit('setUserInfo', result || {
        feGetInfoEnd: true
      })
      commit('setIsLogin', !!(result || {}).sso_uid)
    } else {
      commit('setUserInfo', {
        feGetInfoEnd: true
      })
      commit('setIsLogin', false)
    }
  },
  // 获取是否已登录状态
  async getIsLogin({ dispatch, state }) {
    try {
      if (state.isLogin) {
        return true
      }
      if (!requestCache) {
        requestCache = dispatch('getUserInfo')
      }
      await requestCache
      return state.isLogin
    } finally {
      requestCache = null
    }
  },
  // 获取PCBA用户信息
  async getPcbaUserInfo({ commit, state }) {
    try {
      const res = await getPcbaUserInfo({})
      if (res.retCode === 0 && res.result) {
        commit('SET_PCBA_USER_INFO', res.result)
        return res.result
      }
      return null
    } catch (error) {
      console.error('获取PCBA用户信息失败:', error)
      return null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}